module.exports = __webpack_public_path__ + "img/ueber-mich-2_1920.cdaa468d.jpg";